<template>
	<div class="ztbox">
		<!--<div class="ztheader">
	</div>-->
		<div class="ztcenter">
			<div class="centerone">
				品牌数据
			</div>
			<div class="centertwo flex spa-bet">
				<div class="twoleft">
					<div class="leftbox">
						<p class="lefttext1"><span class="leftspan">1005</span>个</p>
						<p class="lefttext">总数量</p>
					</div>
					<img src="@/assets/images/xin/t11.png" class="leftimg" alt="" />
					<div class="leftbox">
						<p class="lefttext1"><span class="leftspan">2</span>所</p>
						<p class="lefttext">职业本科</p>
					</div>
					<img src="@/assets/images/xin/t11.png" class="leftimg" alt="" />
					<div class="leftbox">
						<p class="lefttext1"><span class="leftspan">212</span>所</p>
						<p class="lefttext">中职院校</p>
					</div>
					<img src="@/assets/images/xin/t11.png" class="leftimg" alt="" />
					<div class="leftbox">
						<p class="lefttext1"><span class="leftspan">50</span>所</p>
						<p class="lefttext">高职院校</p>
					</div>
					<img src="@/assets/images/xin/t11.png" class="leftimg" alt="" />
					<div class="leftbox">
						<p class="lefttext1"><span class="leftspan">10</span>所</p>
						<p class="lefttext">技工院校</p>
					</div>
				</div>
				<div class="tworight">
					<div class="rightitem">
						<img src="@/assets/images/xin/t3.png" class="rightimg" alt="" />
						<p class="righttext">职业本科</p>
						<div class="rightlist">
							<p class="listtext">品牌数量：<span class="listspan">44个</span></p>
							<p class="listtext">品牌占比：<span class="listspan">4%</span></p>
							<p class="listtext">学校品牌平均数：<span class="listspan">10</span></p>
						</div>
					</div>
					<div class="rightitem">
						<img src="@/assets/images/xin/t4.png" class="rightimg" alt="" />
						<p class="righttext">高职院校</p>
						<div class="rightlist">
							<p class="listtext">品牌数量：<span class="listspan">307个</span></p>
							<p class="listtext">品牌占比：<span class="listspan">30%</span></p>
							<p class="listtext">学校品牌平均数：<span class="listspan">10</span></p>
						</div>
					</div>
					<div class="rightitem">
						<img src="@/assets/images/xin/t5.png" class="rightimg" alt="" />
						<p class="righttext">中职院校</p>
						<div class="rightlist">
							<p class="listtext">品牌数量：<span class="listspan">597个</span></p>
							<p class="listtext">品牌占比：<span class="listspan">60%</span></p>
							<p class="listtext">学校品牌平均数：<span class="listspan">10</span></p>
						</div>
					</div>
					<div class="rightitem">
						<img src="@/assets/images/xin/t6.png" class="rightimg" alt="" />
						<p class="righttext">技工院校</p>
						<div class="rightlist">
							<p class="listtext">品牌数量：<span class="listspan">60个</span></p>
							<p class="listtext">品牌占比：<span class="listspan">6%</span></p>
							<p class="listtext">学校品牌平均数：<span class="listspan">10</span></p>
						</div>
					</div>
				</div>
			</div>

			<div class="centerthree">
				<div class="threelist flex spa-bet">
					<div class="listitem">
						<div class="listtitle">
							各城市品牌分布
						</div>
						<div class="listbg" id="ppfb">

						</div>
					</div>
					<div class="listitem">
	     			<div class="listtitle">
	     				品牌归属
	     			</div>
	     			<div class="listbg">
	     				<!-- <div class="listone">共建设了<span class="listonespan">XX</span>个专业，覆盖了省专业的<span class="listonespan">XX</span>%</div> -->
	     				<div style="width:100%;height:274px;" id="bt"></div>
	     			</div>
	     		</div>
					<div class="listitem">
						<div class="listtitle">
							品牌文化
						</div>
						<div class="listbg" id="bq">

						</div>
					</div>
					<!-- <div class="listitem">
						<div class="listtitle">
							资金预算
							<div class="titletext">
								预算金额：
								<span class="titlespan">***万元</span>
							</div>
						</div>
						<div class="listbg" id="bt2">

						</div>
					</div> -->
					<!-- <div class="listitem">
						<div class="listtitle">
							资金使用
							<div class="titletext">
								实际资金使用：
								<span class="titlespan">***万元</span>
							</div>
						</div>
						<div class="listbg">
							<div class="bglist">
								<div class="bgitem">
									<span class="bgi1">省资金使用率</span>
									<span class="bgi2">100%</span>
								</div>
								<div class="bgitem">
									<span class="bgi1">地方资金使用率</span>
									<span class="bgi2">100%</span>
								</div>
							</div>
							<div class="bglist">
								<div class="bgitem">
									<span class="bgi1">学校自筹资金使用率</span>
									<span class="bgi2">100%</span>
								</div>
								<div class="bgitem">
									<span class="bgi1">其他资金使用率</span>
									<span class="bgi2">100%</span>
								</div>
							</div>
							<div style="width:100%; height:218px;" id="zztd">

							</div>
						</div>
					</div> -->
					<div class="listitem ">
						<div class="listtitle">
							教师职称分布
							<!-- 特色文化育人品牌成果 -->
						</div>
						<div class="listbg">
							<div style="width:100%;height:220px" id="bt13"></div>
							<div class="btlist">
	     					<div class="btitem">
	     						<span class="btitemspan">正高</span>
	     						<span class="btitemspan" style="color:#517FD9;">670人</span>
	     						<span class="btitemspan" style="color:#517FD9;">16.25%</span>
	     					</div>
	     					<div class="btitem btitem3" >
	     						<span class="btitemspan">副高</span>
	     						<span class="btitemspan" style="color:#FE8D37;">865人</span>
	     						<span class="btitemspan" style="color:#FE8D37;">20.98%</span>
	     					</div>
	     						<div class="btitem btitem4" >
	     						<span class="btitemspan">初级</span>
	     						<span class="btitemspan"  style="color:#FFC808;">1125人</span>
	     						<span class="btitemspan"  style="color:#FFC808;">27.29%</span>
	     					</div>
	     					<div class="btitem btitem1" >
	     						<span class="btitemspan">中级</span>
	     						<span class="btitemspan" style="color:#80CB4B;" >1231人</span>
	     						<span class="btitemspan" style="color:#80CB4B;" >29.86%</span>
	     					</div>
	     					
	     					<div class="btitem btitem2" >
	     						<span class="btitemspan">无</span>
	     						<span class="btitemspan" style="color:#33BEB7;">231人</span>
	     						<span class="btitemspan" style="color:#33BEB7;">5.62%</span>
	     					</div>
	     				
	     				</div>
						</div>
					</div>
				</div>
				<div class="threelist flex spa-bet">
					<div class="listitem ">
						<div class="listtitle">
							<!-- 教师职称分布 -->
							特色文化育人品牌成果
						</div>
						<div class="listbg">
							<div style="width:100%;height:300px" id="bt3"></div>
							<!-- <div class="btlist">
	     					<div class="btitem">
	     						<span class="btitemspan">正高</span>
	     						<span class="btitemspan" style="color:#517FD9;">670人</span>
	     						<span class="btitemspan" style="color:#517FD9;">16.25%</span>
	     					</div>
	     					<div class="btitem btitem3" >
	     						<span class="btitemspan">副高</span>
	     						<span class="btitemspan" style="color:#FE8D37;">865人</span>
	     						<span class="btitemspan" style="color:#FE8D37;">20.98%</span>
	     					</div>
	     						<div class="btitem btitem4" >
	     						<span class="btitemspan">初级</span>
	     						<span class="btitemspan"  style="color:#FFC808;">1125人</span>
	     						<span class="btitemspan"  style="color:#FFC808;">27.29%</span>
	     					</div>
	     					<div class="btitem btitem1" >
	     						<span class="btitemspan">中级</span>
	     						<span class="btitemspan" style="color:#80CB4B;" >1231人</span>
	     						<span class="btitemspan" style="color:#80CB4B;" >29.86%</span>
	     					</div>
	     					
	     					<div class="btitem btitem2" >
	     						<span class="btitemspan">无</span>
	     						<span class="btitemspan" style="color:#33BEB7;">231人</span>
	     						<span class="btitemspan" style="color:#33BEB7;">5.62%</span>
	     					</div>
	     				
	     				</div> -->
						</div>
					</div>
					<div class="listitem">
						<div class="listtitle">
							品牌内涵
						</div>
						<div class="listbg" ref="wordChart">

						</div>
					</div>
					<div class="listitem">
						<div class="listtitle">
							品牌教学成果
						</div>
						<div class="listbg" id="mgt">

						</div>
					</div>
					<div class="listitem">
						<div class="listtitle">
							<span style="display: inline-block;width:40%;overflow: hidden;"
								title="特色文化育人品牌信息">特色文化育人品牌信息</span>
							<a-select default-value="2024" style="width: 100px; margin-left: 10px;margin-top:7px;"
								@change="handleChange" :dropdownClassName="'customClass'">
								<a-select-option value="2024">2024</a-select-option>
								<a-select-option value="2023">2023</a-select-option>
								<a-select-option value="2022">2022</a-select-option>
								<a-select-option value="2021">2021</a-select-option>
							</a-select>
							<a-select default-value="高职院校" style="width: 100px; margin-left:10px;margin-top:7px;"
								@change="handleChange1" :dropdownClassName="'customClass'">
								<a-select-option value="高职院校">高职院校</a-select-option>
								<a-select-option value="中职院校">中职院校</a-select-option>
								<a-select-option value="职业本科">职业本科</a-select-option>
								<a-select-option value="技工院校">技工院校</a-select-option>
							</a-select>
						</div>
						<div class="listbg">
							<div style="width:100%;height:100%;">


								<table class="tables">
									<thead>
										<tr>
											<th>品牌名称</th>
											<th>学校名称</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>铸魂园林——铸匠魂 培匠根</td>
											<td>山西林业职业技术学院</td>
										</tr>
										<tr>
											<td>“E”遇河东</td>
											<td>山西水利职业技术学院</td>
										</tr>
										<tr>
											<td>党史忆峥嵘 歌曲育新人</td>
											<td>山西艺术职业学院</td>
										</tr>
										<tr>
											<td>传承束玉精神 培养时代新人</td>
											<td>晋中师范高等专科学校</td>
										</tr>
										<tr>
											<td>英语畅谈山西美</td>
											<td>太原旅游职业学院</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<modal-component :show="showModal" :title="title"  @close="showModal = false"></modal-component>

	</div>
</template>

<script>
import * as echarts from 'echarts';
import HighCharts from "highcharts";
import 'echarts-wordcloud';
import  modalComponent from "./modalComponent.vue";
export default {
	data() {
		return {
			showModal:false,
			title:'',
		}
	},
	components:{
		modalComponent
	},
	mounted() {
		window.addEventListener('resize', this.handleResize);
		console.log(window.innerWidth);
		if (window.innerWidth > 1440) {
			// this.mgt(['30%', '70%']);
			this.getppfb('4%');

			this.getMyChart5('180');
			// this.getMyChart6('240');
			this.brandTagAct('bq', ['37%', '48%'], ['57%', '68%'], 20, ['0', '30%'], 16);
		} else {
			// this.mgt(['20%', '50%']);
			this.getppfb('10%');
			this.getMyChart5('140');
			// this.getMyChart6('140');
			this.brandTagAct('bq', ['27%', '38%'], ['47%', '55%'], 10, ['0', '20%'], 14);
		}
		this.getszjd('mgt')
		this.getMyChart3s();
		this.getMyChart3();
		this.getWordChart()
		let VALUE6 = ['太原', '大同', '阳泉', '长治', '晋城', '朔州', '晋中', '运城', '忻州', '临汾', '吕梁'];
		let VALUE11 = [100, 100, 80, 100, 100, 100, 100, 100, 100, 100, 100];
		this.zzt2dd("zztd", VALUE6, VALUE11);
	},
	methods: {
		handleChange() {

		},
		handleChange1() {

		},
		handleResize() {
			console.log(window.innerWidth);
			//        if(){
			//        	
			//        }
		},
		getWordChart() {
			const chart = echarts.init(this.$refs.wordChart);
			chart.setOption({
				series: [{
					type: 'wordCloud',
					data: [
						{ 'name': '爱国主义', 'value': 13 },
						{ 'name': '理想信念', 'value': 14 },
						{ 'name': '责任担当', 'value': 16 },
						{ 'name': '大国工匠', 'value': 15 },
						{ 'name': '劳模精神', 'value': 12 },
						{ 'name': '劳动精神', 'value': 13 },
						{ 'name': '法治规范', 'value': 15 },
						{ 'name': '社会主义核心价值观', 'value': 15 },
						{ 'name': '道德修养', 'value': 17 },],
					sizeRange: [16, 30],
					textStyle: { color: () => this.randomColor(), fontSize: '18-50' }
				}]
			});
		},
		randomColor() {
			const h = Math.floor(Math.random() * 360);
			const s = 80 + Math.floor(Math.random() * 20);
			const l = 60 + Math.floor(Math.random() * 30);

			// HSL转RGB再转HEX
			const a = s * Math.min(l, 100 - l) / 100;
			const f = n => {
				const k = (n + h / 30) % 12;
				const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
				return Math.round(255 * color / 100).toString(16).padStart(2, '0');
			};
			return `#${f(0)}${f(8)}${f(4)}`;
		},
		brandTagAct(id, arr, arr1, value, value1, value2) {
			var myChart = echarts.init(document.getElementById(id));
			let list = [
				{
					name: "非遗文化",
					value: 10,
					label: {
						textStyle: {
							color: "#106bff",
							fontSize: 18,
							fontWeight: 600,
							borderColor: "#517FD9",
						},
					},
				},
				{
					name: "革命文化",
					value: 12,
					label: {
						textStyle: {
							color: "#00b8ff",
							fontSize: 18,
							fontWeight: 600,
							borderColor: "#517FD9",
						},
					},
				},
				{
					name: "红色文化",
					value: 33,
					label: {
						textStyle: {
							color: "#ff6262",
							fontSize: 18,
							fontWeight: 600,
							borderColor: "#517FD9",
						},
					},
				},
				{
					name: "传统文化",
					value: 42,
					label: {
						textStyle: {
							color: "#ffb81a",
							fontSize: 18,
							fontWeight: 600,
							borderColor: "#517FD9",
						},
					},
				},
				{
					name: "其他",
					value: 3,
					label: {
						textStyle: {
							color: "#6fef33",
							fontSize: 18,
							fontWeight: 600,
							borderColor: "#517FD9",
						},
					},
				},
			];

			let list1 = [
				{
					name: "非遗文化",
					value: 10,
					itemStyle: { color: 'rgba(16,108,255,0.3)' }
				},
				{
					name: "革命文化",
					value: 12,
					itemStyle: { color: 'rgba(0,184,255,0.3)' }
				},
				{
					name: "红色文化",
					value: 33,
					itemStyle: { color: 'rgba(255,98,98,0.3)' }
				},
				{
					name: "传统文化",
					value: 42,
					itemStyle: { color: 'rgba(255,184,26,0.3)' }
				},
				{
					name: "其他",
					value: 3,
					itemStyle: { color: 'rgba(111,239,51,0.3)' }
				},
			];
			let angle = 0;
			let option = {
				color: [
					"#106bff",
					"#00b8ff",
					"#ff6262",
					"#ffb81a",
					"#6fef33",
					"#106bff",
					"#8d4bbb",
					"#6635EF",
					"#FFAFDA",
				],
				tooltip: {
					show: false,
				},
				legend: {
					show: false,
				},
				series: [
					{
						name: "访问来源",
						type: "pie",
						selectedMode: "single",
						center: ['50%', '50%'],
						radius: arr,
						label: {
							normal: {
								show: false,
								position: "inner",
								formatter: "{d}%",
								textStyle: {
									color: "#fff",
									fontWeight: "normal",
									fontSize: 20,
								},
							},
						},
						labelLine: {
							normal: {
								show: false,
							},
						},
						itemStyle: {
							normal: {
								borderColor: "#001553",
								borderWidth: 0,
								color: "rgba(16,108,255,0.1)",
							},
						},
						data: list1,
					},
					{
						itemStyle: {
							normal: {
								borderColor: "#001553",
								borderWidth: 4,
							},
						},
						name: "访问来源",
						type: "pie",
						center: ['50%', '50%'],
						radius: arr1,
						label: {
							normal: {
								formatter: "{b|{d}%}\n{hr|}\n{d|{b}}",
								rich: {
									b: {
										fontSize: value2,
										align: "left",
										padding: 4,
									},
									hr: {
										borderColor: "#12EABE",
										width: "100%",
										borderWidth: 2,
										height: 0,
									},
									d: {
										fontSize: value2,
										color: "#fff",
										align: "left",
										padding: 4,
									},
									c: {
										fontSize: value2,
										color: "#fff",
										align: "center",
										padding: 4,
									},
								},
							},
						},
						labelLine: {
							normal: {
								show: true,
								length: value,
								length2: value,
								lineStyle: {
									type: "dashed",
									width: 2,
								},
							},
						},
						data: list,
					},
					{
						name: "ring5",
						type: "custom",
						hoverAnimation: false,
						clockwise: true,
						coordinateSystem: "none",
						z: 20, // 设置 markPoint 的 z-index
						zlevel: 2, // 设置 markPoint 的 zlevel
						renderItem: function (params, api) {
							return {
								type: "arc",
								shape: {
									cx: api.getWidth() / 2,
									cy: api.getHeight() / 2,
									r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.25,
									startAngle: ((270 + -angle) * Math.PI) / 180,
									endAngle: ((40 + -angle) * Math.PI) / 180,
								},
								style: {
									shadowColor: "#4FADFD",
									shadowBlur: 10,
									stroke: "#0CD3DB",
									fill: "transparent",
									lineWidth: 1.5,
								},
								silent: true,
							};
						},
						data: [0],
					},
					{
						name: "访问来源",
						type: "pie",
						clockwise: true,
						hoverAnimation: false,
						coordinateSystem: "none",
						radius: value1,
						center: ['50%', '50%'],
						data: [100],
						itemStyle: {
							normal: {
								color: "#043173",
							},
						},
						label: {
							show: false,
						},
						labelLine: {
							normal: {
								show: false,
								length: value,
								length2: value,
								lineStyle: {
									type: "dashed",
									width: 2,
								},
							},
						},
					},
				],
			};
			function draw() {
				angle = angle + 3;
				myChart.setOption(option, true);
				//window.requestAnimationFrame(draw);
			}

			myChart.on("finished", function () {
				setInterval(function () {
					//用setInterval做动画感觉有问题
					draw();
				}, 100);
				// 在这里执行你想要在渲染完成后执行的代码
			});
			//	  	  myChart.clear();
			myChart.setOption(option);
			let that=this;
			myChart.on('click', function(params) {
						// 高亮被点击项
						myChart.dispatchAction({
							type: 'highlight',
							seriesIndex: params.seriesIndex,
							dataIndex: params.dataIndex
						});
						
						// 显示详细tooltip
						myChart.dispatchAction({
							type: 'showTip',
							seriesIndex: params.seriesIndex,
							dataIndex: params.dataIndex
						});
						
						// 控制台输出点击数据
						// console.log('点击数据:', {
						// 	name: params.name,
						// 	value: params.value,
						// 	percent: params.percent + '%'
						// });
						that.showModal=true;
						that.title=params.name;
						console.log("22222");
		    });
		},
		getMyChart3s() {
			HighCharts.chart("bt13", {
				chart: {
					type: "pie",
					options3d: {
						enabled: true,
						alpha: 50,
						beta: 0,
					},
					backgroundColor: null,
				},
				credits: {
					enabled: false,
				},
				title: {
					text: null,
				},
				legend: {
					enabled: false,
					itemStyle: {
						color: "#fff",
						fontSize: "10",
					},
					//        width: 100, // 设置图例宽度
					symbolHeight: 10, // 调整图例符号高度
					symbolWidth: 10, // 调整图例符号宽度
					symbolRadius: 0, // 调整图例符号圆角
					//        itemMarginTop: 10,
					align: "center", // 图例水平对齐方式（可选值：'left', 'center', 'right'）
					verticalAlign: "bottom", // 图例垂直对齐方式（可选值：'top', 'middle', 'bottom'）
					labelFormatter: function () {
						return this.name;
					}
				},
				plotOptions: {
					pie: {
						size: 180,
						showInLegend: true,
						allowPointSelect: true, //每个扇块能否选中
						depth: 30, //饼图的厚度
						borderWidth: 2,
						borderColor: '#FFFFFF', // 设置边框颜色为白色
						dataLabels: {
							distance: 20, //控制饼图外面的线的长短,为负数时文本内容在饼图内部
							enabled: false, //是否显示饼图的线形tip
						},
					},
				},
				series: [
					{
						size: 150,
						name: "教师职称分布",
						// name: "特色文化育人品牌成果",
						data: [
							["正高", 670, 16.25],
							["副高", 865, 20.98],
							["初级", 1125, 27.29],
							["中级", 1231, 29.86],
							["无", 231, 5.62],
							// ["教改项目数量", 670, 16.25],
							// ["课程申报数量", 865, 20.98],
							// ["教学成果数量", 1125, 27.29],
						],
						colors: ["#517FD9", "#FE8D37", "#FFC808", "#80CB4B", "#38CEC1"],
					},
				],
			});
		},
		getMyChart3() {
			HighCharts.chart("bt3", {
				chart: {
					type: "pie",
					options3d: {
						enabled: true,
						alpha: 50,
						beta: 0,
					},
					backgroundColor: null,
				},
				credits: {
					enabled: false,
				},
				title: {
					text: null,
				},
				legend: {
					enabled: false,
					itemStyle: {
						color: "#fff",
						fontSize: "10",
					},
					//        width: 100, // 设置图例宽度
					symbolHeight: 10, // 调整图例符号高度
					symbolWidth: 10, // 调整图例符号宽度
					symbolRadius: 0, // 调整图例符号圆角
					//        itemMarginTop: 10,
					align: "center", // 图例水平对齐方式（可选值：'left', 'center', 'right'）
					verticalAlign: "bottom", // 图例垂直对齐方式（可选值：'top', 'middle', 'bottom'）
					labelFormatter: function () {
						return this.name;
					}
				},
				plotOptions: {
					pie: {
						size: 180,
						showInLegend: true,
						allowPointSelect: true, //每个扇块能否选中
						depth: 30, //饼图的厚度
						borderWidth: 2,
						borderColor: '#FFFFFF', // 设置边框颜色为白色
						dataLabels: {
							distance: 20, //控制饼图外面的线的长短,为负数时文本内容在饼图内部
							enabled: false, //是否显示饼图的线形tip
						},
					},
				},
				series: [
					{
						// size: 150,
						// name: "教师职称分布",
						name: "特色文化育人品牌成果",
						data: [
							// ["正高", 670, 16.25],
							// ["副高", 865, 20.98],
							// ["初级", 1125, 27.29],
							// ["中级", 1231, 29.86],
							// ["无", 231, 5.62],
							["教改项目数量", 670, 16.25],
							["课程申报数量", 865, 20.98],
							["教学成果数量", 1125, 27.29],
						],
						colors: ["#517FD9", "#FE8D37", "#FFC808", "#80CB4B", "#38CEC1"],
					},
				],
			});
		},
		zzt2dd(id, value, value1) {
			var myChart = echarts.init(document.getElementById(id));
			let option = {
				grid: {
					containLabel: true,
					left: 5,
					right: 15,
					bottom: 15,
					top: 30,
				},
				legend: {
					show: false,
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				xAxis: {
					type: 'category',
					data: value,
					axisLabel: {
						textStyle: {
							color: "#68A8CC"
						},
						formatter: function (value) {
							let rowMAx = 4
							let overValue = ''
							for (let i = 0; i < value.length; i++) {
								if ((i % rowMAx == 0) && (i != 0)) {
									overValue += '\n'
									overValue += value[i]
								} else {
									overValue += value[i]
								}
							}
							return overValue
						},
					},
					axisTick: {
						show: false,
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: "#3c71c1",
						}
					},
				},
				yAxis: {
					type: 'value',
					name: '',
					nameTextStyle: {
						color: '#68A8CC',
					},
					axisLabel: {
						textStyle: {
							color: "#68A8CC"
						},
						formatter: '{value}%'
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: "#68A8CC",
						}
					},
					splitLine: { // y 轴分隔线配置
						show: true, // 是否显示分隔线
						lineStyle: {
							color: '#68A8CC', // 分隔线颜色
						}
					}
				},
				series: [{
					name: '资金使用情况',
					data: value1,
					type: 'bar',
					barWidth: "15",
					barGap: '30%',
					itemStyle: {
						normal: {
							borderColor: '#0083E5', // 边框颜色
							borderWidth: 2,
							color: function (params) { // 内部颜色
								return '#0055A8';
							}
						}
					},
					showBackground: false,
					backgroundStyle: {
						color: '#04195e'
					},
					label: {
						show: true,
						position: 'top',
						color: '#fff',
						formatter: '{c}%'
					}
				},
				]
			};
			myChart.clear();
			myChart.setOption(option);
		},
		getMyChart6(value) {
			HighCharts.chart("bt2", {
				chart: {
					type: "pie",
					options3d: {
						enabled: true,
						alpha: 60,
						beta: 0,
					},
					backgroundColor: null,
				},
				credits: {
					enabled: false,
				},
				title: {
					text: null,
				},
				legend: {
					enabled: false,
					itemStyle: {
						color: "#fff",
						fontSize: "14",
					},
					width: 100, // 设置图例宽度
					symbolHeight: 10, // 调整图例符号高度
					symbolWidth: 10, // 调整图例符号宽度
					symbolRadius: 0, // 调整图例符号圆角
					itemMarginTop: 10,
					align: "right", // 图例水平对齐方式（可选值：'left', 'center', 'right'）
					verticalAlign: "middle", // 图例垂直对齐方式（可选值：'top', 'middle', 'bottom'）
				},
				plotOptions: {
					pie: {
						size: value,
						showInLegend: true,
						allowPointSelect: true, //每个扇块能否选中
						depth: 30, //饼图的厚度
						borderWidth: 2,
						borderColor: '#FFFFFF', // 设置边框颜色为白色
						dataLabels: {
							distance: 20, //控制饼图外面的线的长短,为负数时文本内容在饼图内部
							enabled: true, //是否显示饼图的线形tip
							formatter: function (color) {
								console.log(this.point);
								//			              	+this.point.y+
								return '<b style="color:' + this.point.color + ';font-size:14px;">' + "" + '**万元</b></br>' + this.point.name + "";
							},
							style: {
								color: "#fff",
								textOutline: "none",
								fontSize: 14,
							},
						},
					},
				},
				series: [
					{
						// size: 150,
						name: "使用占比",
						data: [
							["省补贴", 10],
							["其他来源", 10],
							["学校自筹", 20],
							["地方补贴", 60],
						],
						colors: ["#80CB4B", "#FFC808", "#FE8D37", "#517FD9"],
					},
				],
			});
		},
		getMyChart5(value) {
			HighCharts.chart("bt", {
				chart: {
					type: "pie",
					options3d: {
						enabled: true,
						alpha: 50,
						beta: 0,
					},
					backgroundColor: null,
				},
				credits: {
					enabled: false,
				},
				title: {
					text: null,
				},
				legend: {
					enabled: true,
					itemStyle: {
						color: "#fff",
						fontSize: "10",
					},
					//        width: 100, // 设置图例宽度
					symbolHeight: 10, // 调整图例符号高度
					symbolWidth: 10, // 调整图例符号宽度
					symbolRadius: 0, // 调整图例符号圆角
					//        itemMarginTop: 10,
					align: "center", // 图例水平对齐方式（可选值：'left', 'center', 'right'）
					verticalAlign: "bottom", // 图例垂直对齐方式（可选值：'top', 'middle', 'bottom'）
					labelFormatter: function () {
						return this.name;
					}
				},
				plotOptions: {
					pie: {
						size: value,
						showInLegend: true,
						allowPointSelect: true, //每个扇块能否选中
						depth: 30, //饼图的厚度
						borderWidth: 2,
						borderColor: '#FFFFFF', // 设置边框颜色为白色
						dataLabels: {
							distance: 20, //控制饼图外面的线的长短,为负数时文本内容在饼图内部
							enabled: false, //是否显示饼图的线形tip
						},
					},
				},
				series: [
					{
						// size: 150,
						name: "品牌归属",
						data: [
							["农林牧渔大类", 11],
							["资源环境与安全大类", 6],
							["能源动力与材料大类", 2],
							["土木建筑大类", 7],
							["水利大类", 4],
							["装备制造大类", 11],
							["生物与化工大类", 6],
							["轻工纺织大类", 2],
							["食品药品与粮食大类", 7],
							["交通运输大类", 4],
							["电子与信息大类", 11],
							["医药卫生大类", 6],
							["财经商贸大类", 2],
							["旅游大类", 7],
							["文化与艺术大类", 4],
						],
						colors: ["#80CB4B", "#FFC808", "#FE8D37", "#517FD9", "#38CEC1"],
					},
				],
			});
		},
		getppfb(value) {
			var myChart = echarts.init(document.getElementById('ppfb'));
			let option = {
				color: [
					'#007380',
					'#664A31',
					'#004997',
					'#42237B'
				],
				title: {
					text: ''
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				legend: {
					textStyle: {
						color: '#E9EAEF' // 设置图例文本颜色
					},
				},
				grid: {
					left: '3%',
					right: value,
					bottom: '3%',
					containLabel: true
				},
				xAxis: {
					type: 'value',
					boundaryGap: [0, 0.01],
					axisLabel: {
						textStyle: {
							color: "#68A8CC"
						},
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: "#68A8CC",
						}
					},

				},
				yAxis: {
					type: 'category',
					// data: ['太原', '大同', '阳泉', '长治', '晋城'],
					data: ['太原', '吕梁', '晋中', '运城', '临汾', '朔州', '晋城', '长治', '大同', '忻州', '阳泉'],
					axisLabel: {
						textStyle: {
							color: "#68A8CC"
						},

					},
					axisLine: {
						show: true,
						lineStyle: {
							color: "#68A8CC",
						}
					},
					splitLine: { // y 轴分隔线配置
						show: false, // 是否显示分隔线
						lineStyle: {
							color: '#68A8CC', // 分隔线颜色
						}
					},
				},
				dataZoom: [{  // 数据缩放区域
					type: 'slider',  // 滑动条类型
					yAxisIndex: 0,   // 对应 yAxis 的索引
					start: 0,         // 初始窗口范围的起始百分比
					end: 50, // 初始窗口范围的结束百分比
					showDataShadow: false, // 是否显示数据阴影
					bottom: 0,
					textStyle: {
						color: 'transparent' // 修改滑块文字颜色
					},
					zoomLock: true,
					top: 60,
					left: 0,
					width: '10px',
					height: '70%',
				}],
				series: [
					{
						name: '职业本科',
						type: 'bar',
						//   data: [0, 0, 0, 0, 0],
						data: [4, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0],
						itemStyle: {
							normal: {
								borderColor: '#00FFC6', // 边框颜色
								borderWidth: 2,
								color: function (params) { // 内部颜色
									return '#007380';
								}
							}
						},
					},
					{
						name: '高职院校',
						type: 'bar',
						//   data: [217, 10, 10, 18, 4],
						data: [62, 0, 9, 12, 10, 1, 1, 1, 5, 3, 1],
						itemStyle: {
							normal: {
								borderColor: '#FF9C00', // 边框颜色
								borderWidth: 2,
								color: function (params) { // 内部颜色
									return '#664A31';
								}
							}
						},
					},
					{
						name: '中职院校',
						type: 'bar',
						//   data: [96, 40, 2, 12, 13],
						data: [65, 22, 46, 43, 35, 8, 16, 35, 29, 14, 25],
						itemStyle: {
							normal: {
								borderColor: '#009CFF', // 边框颜色
								borderWidth: 2,
								color: function (params) { // 内部颜色
									return '#004997';
								}
							}
						},
					},
					{
						name: '技工院校',
						type: 'bar',
						//   data: [8, 8, 0, 7, 15],
						data: [8, 0, 1, 5, 1, 0, 9, 6, 3, 0, 1],
						itemStyle: {
							normal: {
								borderColor: '#A63AB9', // 边框颜色
								borderWidth: 2,
								color: function (params) { // 内部颜色
									return '#42237B';
								}
							}
						},
					}
				]
			};
			myChart.clear();
			myChart.setOption(option);
		},
		mgt(arr) {

			var myChart = echarts.init(document.getElementById('mg'));
			var colorList = ['#4450BB', '#5F6CE6', '#58C9F7', '#F74D4E', '#FAC231'];
			var title = ['品牌精神1', '品牌精神2', '品牌精神3', '品牌精神4', '品牌精神5'];
			var dataValue = ['20', '20', '20', '20', '20'];
			var dataList = title.map((item, index) => {
				return {
					name: item,
					value: dataValue[index],
					itemStyle: {
						color: colorList[index]
					},
				};
			});
			var center = ['50%', '50%'];
			var option = {
				color: colorList,
				series: [
					{
						type: 'pie',
						center: center,
						radius: arr, // 玫瑰图半径范围
						roseType: 'radius', // 玫瑰图类型
						label: {
							show: true,
							position: 'outside',
							alignTo: 'labelLine',
							//					            backgroundColor: '#fff',
							padding: [3, -3, 3, -3],
							formatter: function (params) {
								return `{a|${params.value}%}\n{b${params.dataIndex}|${params.name}}`
							},
							rich: {
								a: {
									//					                  padding: [10, 100, 10,100],
									fontSize: '14px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									color: '#fff',
									lineHeight: 24,
								},
								b0: {
									color: '#4450BB',
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								},
								b1: {
									color: '#5F6CE6',
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								},
								b2: {
									color: '#58C9F7',
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								},
								b3: {
									color: '#F74D4E',
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								},
								b4: {
									color: '#FAC231',
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								}
							}
						},
						data: dataList,
					},
				],
			}
			myChart.clear();
			myChart.setOption(option);
		},
		getszjd(id) {
			let value = ['太原', '大同', '阳泉', '长治', '晋城', '朔州', '晋中', '运城', '忻州', '临汾', '吕梁'];
			let value1 = [15, 10, 8, 8, 8, 9, 9, 8, 9, 7, 9];
			var myChart = echarts.init(document.getElementById(id));
			let option = {
				grid: {
					containLabel: true,
					left: 5,
					right: 15,
					bottom: 15,
					top: 30,
				},
				legend: {
					show: false,
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				xAxis: {
					type: 'category',
					data: value,
					axisLabel: {
						textStyle: {
							color: "#68A8CC"
						},
						formatter: function (value) {
							let rowMAx = 4
							let overValue = ''
							for (let i = 0; i < value.length; i++) {
								if ((i % rowMAx == 0) && (i != 0)) {
									overValue += '\n'
									overValue += value[i]
								} else {
									overValue += value[i]
								}
							}
							return overValue
						},
					},
					axisTick: {
						show: false,
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: "#3c71c1",
						}
					},
				},
				yAxis: {
					type: 'value',
					name: '',
					nameTextStyle: {
						color: '#68A8CC',
					},
					axisLabel: {
						textStyle: {
							color: "#68A8CC"
						},
						formatter: '{value}'
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: "#68A8CC",
						}
					},
					splitLine: { // y 轴分隔线配置
						show: true, // 是否显示分隔线
						lineStyle: {
							color: '#68A8CC', // 分隔线颜色
						}
					}
				},
				series: [{
					name: '思政实践基地个数',
					data: value1,
					type: 'bar',
					barWidth: "15",
					barGap: '30%',
					itemStyle: {
						normal: {
							borderColor: '#0083E5', // 边框颜色
							borderWidth: 2,
							color: function (params) { // 内部颜色
								return '#0055A8';
							}
						}
					},
					showBackground: false,
					backgroundStyle: {
						color: '#04195e'
					},
					label: {
						show: true,
						position: 'top',
						color: '#fff',
						formatter: '{c}'
					}
				},
				]
			};
			myChart.clear();
			myChart.setOption(option);
		},

	}
}
</script>

<style lang="scss" scoped>
p {
	margin: 0px;
	padding: 0px;
}

.flex {
	display: flex;
}

.spa-bet {
	justify-content: space-between;
}

.ztbox {
	width: 100%;
	height: auto;
	/*background: url("../../assets/images/bigdatas/banner.png") no-repeat;
  background-repeat: no-repeat;*/
	/*background-size: 100% 100%;*/
	/*padding:0px 20px 20px;*/
	box-sizing: border-box;
	/*max-width:1366px;*/
	flex: 1;

	/*.ztheader{
  	 height:80px;
  	 margin-bottom:10px;
  }*/
	.ztcenter {
		width: 100%;

		.centerone {
			width: 100%;
			height: 48px;
			background: url("../../assets/images/xin/ts1.png") no-repeat;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			padding-left: 30px;
			line-height: 48px;
			font-weight: bold;
			font-size: 20px;
			color: #02F4F5;
		}

		.centertwo {
			width: 100%;
			height: 128px;
			background: url("../../assets/images/xin/ts2.png") no-repeat;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			padding: 10px;
			box-sizing: border-box;

			.twoleft {
				/*max-width:496px;*/
				width: 25%;
				height: 108px;
				background: url("../../assets/images/xin/t10.png") no-repeat;
				background-repeat: no-repeat;
				background-size: 100% 100%;
				padding: 20px 0px;
				box-sizing: border-box;
				display: flex;
				justify-content: flex-start;
				align-items: center;

				.leftbox {
					height: 68px;
					width: 24%;
				}

				.leftimg {
					width: 1px;
					height: 68px;
				}

				.lefttext {
					font-size: 16px;
					text-align: center;
					color: #fff;
					line-height: 34px;
				}

				.leftspan {
					color: #FFD70E;
					font-size: 20px;
				}

				.lefttext1 {
					font-size: 12px;
					text-align: center;
					color: #fff;
					line-height: 34px;
				}
			}

			.tworight {
				width: 74%;
				display: flex;
				justify-content: space-around;
				align-items: center;

				.rightitem {
					width: calc((100% - 30px)/4);
					height: 108px;
					background: url("../../assets/images/xin/t12.png") no-repeat;
					background-repeat: no-repeat;
					background-size: 100% 100%;
					padding: 20px 10px;
					box-sizing: border-box;
					display: flex;
					justify-content: flex-start;
					align-items: center;

					.rightimg {
						width: 45px;
						height: 45px;
						margin-right: 5px;
					}

					.righttext {
						font-size: 16px;
						text-align: center;
						color: #fff;
						width: 120px;
					}

					.rightlist {
						width: 60%;
						height: 88px;

						.listtext {
							font-size: 16px;
							line-height: 29px;
							color: #fff;
							white-space: nowrap;
							/* 不换行 */
							overflow: hidden;
							/* 隐藏超出部分 */
							text-overflow: ellipsis;
							/* 超出部分用省略号表示 */
						}

						.listspan {
							color: #7CFFFD;
						}
					}
				}
			}
		}

		.centerthree {
			margin-top: 20px;

			.threelist {
				margin-bottom: 10px;

				.listitem {
					width: calc((100% - 30px)/4);

					.listtitle {
						width: 100%;
						height: 48px;
						background: url("../../assets/images/xin/t21.png") no-repeat;
						background-repeat: no-repeat;
						background-size: 100% 100%;
						padding-left: 30px;
						line-height: 48px;
						font-weight: bold;
						font-size: 20px;
						color: #02F4F5;
						position: relative;
						display: flex;

						.titletext {
							height: 48px;
							position: absolute;
							top: 0px;
							right: 10px;
							font-size: 16px;
							line-height: 48px;
							color: #fff;

						}

						.titlespan {
							color: #F9D314;
						}
					}

					.listbg {
						width: 100%;
						height: 320px;
						background: url("../../assets/images/xin/t20.png") no-repeat;
						background-repeat: no-repeat;
						background-size: 100% 100%;
						padding: 10px;
						box-sizing: border-box;
						overflow: hidden;

						table {
							width: 100% !important;
						}

						.listone {
							width: 100%;
							height: 26px;
							background: url("../../assets/images/xin/t23.png") no-repeat;
							background-repeat: no-repeat;
							background-size: 100% 100%;
							text-align: center;
							line-height: 26px;
							font-size: 16px;
							color: #fff;

							.listonespan {
								color: #FFD70E;
								font-weight: bold;
							}
						}

						.bglist {
							height: 32px;
							margin-bottom: 10px;
							display: flex;
							justify-content: space-between;
							align-items: center;

							.bgitem {
								width: calc((100% - 10px)/2);
								height: 32px;
								display: flex;
								justify-content: space-between;
								align-items: center;
								background: url("../../assets/images/xin/t22.png") no-repeat;
								background-repeat: no-repeat;
								background-size: 100% 100%;
								padding: 0px 10px;
								box-sizing: border-box;
							}

							.bgi1 {
								font-size: 16px;
								color: #fff;
							}

							.bgi2 {
								font-size: 16px;
								color: #FFD70E;
								font-weight: bold;
							}
						}
					}

					.btlist {
						width: 100%;
						padding: 0px 10px;
						display: flex;
						justify-content: space-between;
						flex-wrap: wrap;

						.btitem {
							width: calc((100% - 10px)/2);
							height: 28px;
							padding: 0px 10px;
							box-sizing: border-box;
							display: flex;
							justify-content: space-between;
							align-items: center;
							background: url("../../assets/images/xin/t31.png") no-repeat;
							background-repeat: no-repeat;
							background-size: 100% 100%;

							.btitemspan {
								color: #fff;
								font-size: 14px;
							}
						}

						.btitem1 {
							background: url("../../assets/images/xin/t32.png") no-repeat;
						}

						.btitem2 {
							background: url("../../assets/images/xin/t33.png") no-repeat;
						}

						.btitem3 {
							background: url("../../assets/images/xin/t34.png") no-repeat;
						}

						.btitem4 {
							background: url("../../assets/images/xin/t35.png") no-repeat;
						}
					}
				}

			}
		}
	}

	.tables {
		width: 100%;

		thead {
			tr {
				background-color: #08276F;
				height: 48px;

				th {
					width: 50%;
					height: 48px;
					display: inline-block;
					line-height: 48px;
					text-align: center;
					font-size: 16px;
					color: #8298FB;
				}
			}
		}

		tbody {
			tr {
				height: 46px;
				border-bottom: 1px dotted #5E6C92;

				td {
					width: 50%;
					height: 46px;
					line-height: 46px;
					text-align: center;
					font-size: 16px;
					color: #fff;
					display: inline-block;
					white-space: nowrap;
					/* 不换行 */
					overflow: hidden;
					/* 隐藏超出部分 */
					text-overflow: ellipsis;
				}
			}
		}
	}
}

@media screen and (max-width: 1440px) and (min-width: 1367px) {

	.leftspan,
	.centerone {
		font-size: 18px !important;
	}

	.listtitle {
		font-size: 18px !important;
	}

	.lefttext,
	.titletext,
	.listone {
		font-size: 14px !important;
	}

	.rightimg {
		width: 35px !important;
		height: 35px !important;
	}

	.righttext {
		font-size: 14px !important;
	}

	.listtext,
	.bgi1,
	.bgi2 {
		font-size: 14px !important;
	}

	.tables {
		width: 100%;

		thead {
			tr {
				background-color: #08276F;
				height: 48px;

				th {
					width: 50%;
					height: 48px;
					line-height: 48px;
					text-align: center;
					font-size: 14px !important;
					color: #8298FB;
				}
			}
		}

		tbody {
			tr {
				height: 46px;
				border-bottom: 1px dotted #5E6C92;

				td {
					width: 50%;
					height: 46px;
					line-height: 46px;
					text-align: center;
					font-size: 14px !important;
					color: #fff;
					white-space: nowrap;
					/* 不换行 */
					overflow: hidden;
					/* 隐藏超出部分 */
					text-overflow: ellipsis;
				}
			}
		}
	}
}

@media screen and (max-width: 1366px) {

	.leftspan,
	.centerone {
		font-size: 16px !important;
	}

	.lefttext,
	.titletext,
	.listone {
		font-size: 14px !important;
	}

	.rightimg {
		width: 35px !important;
		height: 35px !important;
	}

	.righttext {
		font-size: 12px !important;
		width: 80px !important;
	}

	.listtext,
	.bgi1,
	.bgi2 {
		font-size: 12px !important;
	}

	.listtitle {
		font-size: 16px !important;
	}

	.tables {
		width: 100%;

		thead {
			tr {
				background-color: #08276F;
				height: 48px;

				th {
					width: 50%;
					height: 48px;
					line-height: 48px;
					text-align: center;
					font-size: 14px !important;
					color: #8298FB;
				}
			}
		}

		tbody {
			tr {
				height: 46px;
				border-bottom: 1px dotted #5E6C92;

				td {
					width: 50%;
					height: 46px;
					line-height: 46px;
					text-align: center;
					font-size: 14px !important;
					color: #fff;
					white-space: nowrap;
					/* 不换行 */
					overflow: hidden;
					/* 隐藏超出部分 */
					text-overflow: ellipsis;
				}
			}
		}
	}
}

::v-deep .ant-select-selection {
	background-color: #01297d;
	color: #fff;
	border-color: #2669e6;
}

::v-deep .ant-select-dropdown {
	background-color: #01297d;
	color: #fff;
}

::v-deep .ant-select-arrow {
	background-color: #01297d;
	color: #fff;
}

::v-deep .ant-radio-button-wrapper {
	color: #999;
	background-color: #0d308d;
	border-color: #ffffff00;
	border-radius: 0;
}
</style>

<style lang="scss">
.customClass {
	background: #01297d;

	.ant-select-dropdown-menu-item {
		background-color: #01297d;
		color: #fff;

		&:not(:last-child) {
			border-bottom: 1px solid #999;
		}

		&:hover:not(.ant-select-dropdown-menu-item-disabled) {
			background-color: #0f5bff;
		}
	}
}
</style>